var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12","md":"3","sm":"3"}},[_c('BaseButton',{attrs:{"color":"whiteSmoke","icon":""},on:{"click":function($event){return _vm.$emit('back')}}},[_c('p',{staticClass:"gray--text"},[_c('v-icon',{attrs:{"color":"primary ","size":"14"}},[_vm._v(" fa-chevron-left ")]),_vm._v(" VOLTAR ")],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }